module.exports = __webpack_public_path__ + "static/media/pencil.707b9a20.svg";